import { ESocketActionTypes } from '../../actions/socket';
import { ERequestApiStatus, TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export function socketReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case ESocketActionTypes.Pending:
      return {
        ...state,
        socket: {
          ...state.socket,
          status: ERequestApiStatus.Pending,
        },
      };
    case ESocketActionTypes.Succeed:
      return {
        ...state,
        socket: {
          ...state.socket,
          status: ERequestApiStatus.Succeed,
        },
      };
    case ESocketActionTypes.Failed:
      return {
        ...state,
        socket: {
          ...state.socket,
          status: ERequestApiStatus.Failed,
        },
      };
    default:
      return state;
  }
}
